import TitleAndDomainPoolSetting from "./TitleAndDomainPoolSetting";

export default TitleAndDomainPoolSetting;
